// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC8h_ySxbxEwdt__ObKp4HM8lh2fDcXnwU",
  authDomain: "matops-home.firebaseapp.com",
  databaseURL: "https://matops-home-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "matops-home",
  storageBucket: "matops-home.appspot.com",
  messagingSenderId: "890000438315",
  appId: "1:890000438315:web:3b849c2d23005473b1266e",
  measurementId: "G-XDCRX037SE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

// Export the auth, provider, and functions in a modular way
export { auth, provider, signInWithPopup, signOut, onAuthStateChanged };
